import { CssBaseline, Theme } from '@mui/material';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import LPAppBar from '../../app/components/LPAppBar';
import LPDrawer from '../../app/components/LPDrawer';
import ShiftHome from '../../app/components/ShiftHome';
import UISize from '../../models/UISize';
import { AppState } from '../../store/rootReducer';
import { useStyles } from '../../assets/styles/DefaultPageStyle';


export default function NF07Page(/*props*/) {
  const { classes } = useStyles();
  const screenSize: UISize = useSelector(state => (state as AppState).ui.screenSize);
  const open = screenSize.width > 0 && screenSize.width < 1200 ? false : true;
  //
  const button: boolean = useSelector((state) => (state as AppState).ui.isSandwichButtonTurnedOn);
  //
  return (
    <div className={classes.root}>
      <ShiftHome />
      <CssBaseline />
      <LPDrawer />
      <main className={clsx(classes.content, { [classes.contentShift]: button ? true : open })}>
        <LPAppBar ismenuvisible={true} />
        <>{/** Content */}</>
      </main>
    </div>
  );
}